import API from "./API";
// import adminAPI from "./adminAPI.js";
import Alert from "../stores/alerts";
import app from "../stores/app";
import user from "../stores/user";
import {writable} from "svelte/store";

export const LOADER = {
    NONE: 0,
    PAGE: 1,
    POPUP: 2,
}

const mm = writable(false);

const R = {
    handle: async (func, params, success, failure, loader = 0) => {
        if (loader == LOADER.PAGE) {
            app.showPageLoader();
        } else if (loader == LOADER.POPUP) {
            app.showPopupLoader();
        }

        mm.set(true);
        //const [err, result] = await func(params);
        const result = await func(params);
        mm.set(false);

        if (loader == LOADER.PAGE) {
            app.hidePageLoader();
        } else if (loader == LOADER.POPUP) {
            app.hidePopupLoader();
        }

        if (result.error) {
            if (result.error.code == 'no_login') {
                Alert.warning("Member account", "You have been logged out of your account!");
                user.clearToken();
            }
            failure(result.error);
        } else {
            success(result.data);
        }
    },

    app: {
        login: (data) => API.POST(`login`, data),
        initialize: () => API.GET('initialize'),
    },

    checkIn: {
        initialize: (data) => API.POST('checkin/initialize', data),
        create: (data) => API.POST('checkin/create', data),
    },

    hotel: {
        index: (data) => API.POST('hotels', data),
    },

    member: {
        // index: (data) => API.POST('members', data),
        dashboard: () => API.GET('account/dashboard'),
        points: () => API.GET('account/points'),
        pointsLog: () => API.GET('account/points-log'),
        initialize: () => API.GET(`account/initialize`),
        signup: (data) => API.POST('account/signup', data),
        details: (id) => API.GET(`account/details`),
        edit: (data) => API.POST(`account/edit`, data),
        setPassword: (data) => API.POST('account/set-password', data),
        validatePointsTransfer: (data) => API.POST('account/validate-points-transfer', data),

        // create: (data) => API.POST('member/create', data),

        //
        // log: (id) => API.GET(`member/${id}/log`),
        //
        // points: (id) => API.GET(`member/${id}/points`),
        // addPoints: (data) => API.POST(`member/add-points`, data),
        // removePoints: (data) => API.POST(`member/remove-points`, data),
        // transferPoints: (data) => API.POST(`member/transfer-points`, data),
        // deletePoints: (id) => API.POST(`member/delete-points`, {id}),
    },

    actionRequest: {
        request: (data) => API.POST('action/request', data),
        confirm: (request) => API.POST('action/confirm', {request}),
    },

    // apiRequest: {
    //     sendMail: (data) => adminAPI.POST('brevo-mail', data),
    // }
};

export default R;
export {mm as requestingStore};